import AvisMaisonLogo from './logo'
import {avisMaisonStylesFR} from './styles'

const baseConfig = {
  domainName: 'avismaison' as const,
  domainType: 'eu' as const,
  siteName: 'Avis Maison',
  logo: <AvisMaisonLogo className="size-8 shrink-0 tablet:size-6" locale="fr" />,
  favicon: '/favicons/avismaison.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-L5P4Q96PYG',
    camelCaseUrl: 'AvisMaison.fr',
    title: (category: string, _count: string) => `Avis ${category} : Comparatifs, Tests et Guides d’Achat Fiables`,
    description: (_category?: string, _count?: string) =>
      `Trouvez facilement les meilleurs équipements pour votre maison grâce à des avis experts, des comparatifs précis et des conseils pratiques utiles.`,
    styles: avisMaisonStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
